import React, {useState} from "react";
import "./FiltersPanel.scss";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {ReactSelectDesktopStyles} from "../../../constants/ReactSelect.constants";
import LanguageService from "../../../services/Language.service";
import {
    currency,
    noteSubType,
    noteType,
    productClass,
    SEARCH,
    status,
    termFrom,
    termTo
} from "../constants/NewCurrentOfferings";
import TranslateComponent from "../../misc/translate/Translate.component";
import {
    DATE_INPUT_FORMAT,
    DATE_INPUT_FORMAT_FR,
    LANGUAGE_ENGLISH,
    PLACEHOLDER_DATE_FORMAT,
    PLACEHOLDER_DATE_FORMAT_FR
} from "../../../constants/Misc.constants";
import {CATEGORY, NOTE_SEARCH_DROPDOWN_OPTIONS, NOTE_SEARCH_LABEL_KEYS} from "../../../constants/Notes.constants";
import EnumService from "../../../services/Enum.service";

export default function FiltersPanel({onFilterSearch, disableFilters}) {
    const [filters, setFilters] = useState({});
    const datePickerRefs = [];

    const handleChange = (key, value) => {
        const selectedValue = value || "";
        setFilters((prev) => ({...prev, [key]: selectedValue}));
    };
    const handleSearch = () => {
        onFilterSearch && onFilterSearch(filters);
    };
    const handleReset = () => {
        setFilters({});
    };

    const createDropDownOptions = (category, sort, withEnglishValue = false) => {
        const enums = EnumService.getEnums(category);

        if (sort) {
            enums.sort((a, b) => a.valueEn.localeCompare(b.valueEn));
        }

        return enums.map(e => {
            if (LanguageService.isLanguage(LANGUAGE_ENGLISH)) {
                return {value: e.valueEn, label: e.valueEn};
            } else {
                return {value: withEnglishValue ? e.valueEn : e.valueFr, label: e.valueFr};
            }
        });
    }

    const termOptions = NOTE_SEARCH_DROPDOWN_OPTIONS.TERMS.map(
        (term) => ({value: term, label: term})
    );

    const statusOptions = NOTE_SEARCH_DROPDOWN_OPTIONS.CURRENT_STATUSES.map(
        (option) => ({ value: option[1], label: LanguageService.translate(option[0]) })
        )
        .concat(
            createDropDownOptions(CATEGORY.STATUS_OVERRIDE, true, true)
        )
        .sort((a, b) => a.label.localeCompare(b.label));

    const fields = [
        [
            {
                languageCode: LanguageService.translate(NOTE_SEARCH_LABEL_KEYS.PRODUCT_TYPE),
                label: NOTE_SEARCH_LABEL_KEYS.PRODUCT_TYPE,
                key: noteType,
                type: "select",
                options: createDropDownOptions(CATEGORY.NOTE_TYPE, false)
            },
            {
                languageCode: LanguageService.translate(NOTE_SEARCH_LABEL_KEYS.STRUCTURE_TYPE),
                label: NOTE_SEARCH_LABEL_KEYS.STRUCTURE_TYPE,
                key: noteSubType,
                type: "select",
                options: createDropDownOptions(CATEGORY.NOTE_SUB_TYPE, true)
            },
            {
                languageCode: LanguageService.translate(NOTE_SEARCH_LABEL_KEYS.CURRENCY),
                label: NOTE_SEARCH_LABEL_KEYS.CURRENCY,
                key: currency,
                type: "select",
                options: createDropDownOptions(CATEGORY.CURRENCY, true)
            },
            {
                languageCode: LanguageService.translate(NOTE_SEARCH_LABEL_KEYS.PRODUCT_CLASS),
                label: NOTE_SEARCH_LABEL_KEYS.PRODUCT_CLASS,
                key: productClass,
                type: "select",
                options: createDropDownOptions(CATEGORY.PRODUCT_CLASS, true)
            }
        ],
        [
            {
                languageCode: LanguageService.translate(NOTE_SEARCH_LABEL_KEYS.TERM_FROM),
                label: NOTE_SEARCH_LABEL_KEYS.TERM_FROM,
                key: termFrom,
                type: "select",
                options: termOptions
            },
            {
                languageCode: LanguageService.translate(NOTE_SEARCH_LABEL_KEYS.TERM_TO),
                label: NOTE_SEARCH_LABEL_KEYS.TERM_TO,
                key: termTo,
                type: "select",
                options: termOptions
            },
            {
                languageCode: LanguageService.translate(NOTE_SEARCH_LABEL_KEYS.CURRENT_STATUS),
                label: NOTE_SEARCH_LABEL_KEYS.CURRENT_STATUS,
                key: status,
                type: "select",
                options: statusOptions
            }
        ]
    ]

    return (<div className="container-fluid sn-offerings-search">
        {fields.map((row, i) => (

            <div className="row" key={i}>
                {row.map(({label, key, type, options, languageCode}) => (
                    <div className="col-xs-12 col-sm-6 col-md-3 mb-25 mb-sm-25 mb-md-25" key={key + i}>
                        {type === "text" && (
                            <input
                                type="text"
                                className="form-control search" id="search" style={{backgroundColor: "white"}}
                                value={filters[key] || ""}
                                onChange={(e) => handleChange(key, e.target.value)}
                                placeholder={LanguageService.translate(languageCode)}
                                data-testid={key}
                            />
                        )}

                        {type === "select" && (
                            <Select
                                data-testid={key}
                                options={options}
                                isClearable={true}
                                value={options.find((o) => o.value === filters[key]) || ""}
                                name={label}
                                onChange={(e) => handleChange(key, e?.value)}
                                styles={ReactSelectDesktopStyles}
                                placeholder={LanguageService.translate(languageCode)}
                            />
                        )}

                        {type === "date" && (
                            <div className="row">
                                <div className="col-4 d-flex align-items-center sn-offerings-search-label-col">
                                    <label><TranslateComponent label={LanguageService.translate(languageCode)}/></label>
                                </div>
                                <div className="col-8 sn-offerings-search-date-col">
                                    <DatePicker
                                        ref={(r) => datePickerRefs[key] = r}
                                        wrapperClassName="w-100"
                                        className="form-control text-right"
                                        placeholderText={LanguageService.chooseLang(PLACEHOLDER_DATE_FORMAT, PLACEHOLDER_DATE_FORMAT_FR)}
                                        selected={filters[key]}
                                        onChange={(value) => handleChange(key, value)}
                                        dateFormat={LanguageService.chooseLang(DATE_INPUT_FORMAT, DATE_INPUT_FORMAT_FR)}
                                    />
                                    <span
                                        className="td-icon td-icon-bookAppointment sn-offerings-search-calendar-icon"
                                        onClick={() => {
                                            datePickerRefs[key].setOpen(true)
                                        }}
                                    ></span>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        ))}

        <div className="row">
            <div className="col-xs-6 col-sm-6 col-md-3 mb-25 mb-sm-0 mb-md-0">
                <button
                    data-testid={"advanced-search-button"}
                    className="btn btn-block td-btn-primary-light"
                    onClick={handleSearch}
                    disabled={disableFilters}>
                    <TranslateComponent label={SEARCH}/>
                </button>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-3">
                <button
                    className="btn btn-block td-btn-secondary-clear clear-btn"
                    onClick={handleReset}
                    disabled={disableFilters}>
                    <TranslateComponent label={"RESET"}/>
                </button>
            </div>
        </div>
    </div>);
}
